function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e) {
  var t = {};

  function n(o) {
    if (t[o]) return t[o].exports;
    var r = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  n.m = e, n.c = t, n.d = function (e, t, o) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(o, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return o;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 107);
}({
  107: function _(e, t, n) {
    "use strict";

    n.r(t);
    n(108), n(109);
  },
  108: function _(e, t, n) {},
  109: function _(e, t) {
    app.modules.initPhoneMask = function (e) {
      var t = app.config.initPhoneMask,
          n = t ? t.phoneCode : "+7",
          o = {
        defaultPattern: t ? t.phonePattern : "+0 (000) 000-00-00",
        simplePattern: "+000000000000000",
        nationalPattern: "000000000000000",
        params: {
          placeholder: t ? t.phonePlaceholder : "+7 (___) ___-__-__",
          onKeyPress: function onKeyPress() {
            r.onlyDefaultCode || a.apply(null, arguments);
          }
        }
      },
          r = {};

      function a(e, t, o) {
        var a, i;
        a = ~e.indexOf(n) ? "defaultPattern" : (i = e.match(/\d/)) && "8" === i[0] ? "nationalPattern" : "simplePattern", o.mask(r.onlyDefaultCode ? r.defaultPattern.replace("+0", n) : r[a], r.params), r.notRemoveCode && (o.on("keydown", function (e) {
          (8 === e.keyCode || 107 === e.keyCode) && o[0].selectionStart <= n.length && e.preventDefault();
        }), o.click(function () {
          $(this).val() || $(this).val(n);
        }));
      }

      function i(e) {
        $(e || ".js-phone-mask").each(function () {
          var e = $(this);
          $.extend(r, o, e.data("phoneMaskOptions")), a(e.val() || e.text(), 0, e);
        });
      }

      return e.load = function () {
        i(), $doc.on("init:phoneMask", function (e) {
          i(e.target !== document && e.target);
        });
      }, e;
    }(app.modules.initPhoneMask || {});
  }
});